import {
    CloseOutlined,
    CopyOutlined,
    InfoCircleOutlined,
} from "@ant-design/icons";
import { Button, Flex } from "antd";
import dayjs from "dayjs";
import { FC } from "react";
import { formatUAHStandard } from "tm-shared/utils";

import { PrimaryText, SecondaryText } from "@/shared/ui/Typography";

import { StyledCard, StyledRemoveButton, StyledSum } from "./Styled";

interface InvoiceCardProps {
    consignmentId: string;
    shipmentDate: string;
    debt: number;
    address?: string;
    contragent?: string;
    onInfo: () => void;
    onRemove: () => void;
    onCopy: () => void;
}

export const InvoiceCard: FC<InvoiceCardProps> = ({
    consignmentId,
    shipmentDate,
    debt,
    address,
    contragent,
    onInfo,
    onRemove,
    onCopy,
}) => {
    return (
        <StyledCard vertical gap={8}>
            <SecondaryText
                fontSize={16}
                style={{ textWrap: "wrap", fontWeight: 500 }}
            >
                {consignmentId}
            </SecondaryText>

            {contragent && (
                <SecondaryText
                    fontSize={16}
                    style={{ textWrap: "wrap", fontWeight: 500 }}
                >
                    {contragent}
                </SecondaryText>
            )}

            {address && (
                <SecondaryText
                    fontSize={14}
                    style={{ textWrap: "wrap", fontWeight: 500 }}
                >
                    {address}
                </SecondaryText>
            )}

            <Flex justify="space-between" gap={8}>
                <PrimaryText
                    fontSize={16}
                    style={{ textWrap: "wrap", opacity: 0.8 }}
                >
                    {dayjs(shipmentDate).format("DD.MM.YYYY")}
                </PrimaryText>

                <StyledSum fontSize={18} fontWeight="600">
                    {formatUAHStandard(debt)}
                </StyledSum>
            </Flex>

            <Flex justify="space-between" align="center">
                <Button
                    type="text"
                    icon={<InfoCircleOutlined />}
                    onClick={() => onInfo()}
                    style={{ padding: 0 }}
                >
                    Інфо
                </Button>

                <Button
                    type="text"
                    icon={<CopyOutlined />}
                    onClick={() => onCopy()}
                />
            </Flex>

            <StyledRemoveButton
                type="text"
                icon={<CloseOutlined />}
                onClick={() => onRemove()}
            />
        </StyledCard>
    );
};
